export default function genererCritereRechercheProduitEcran(isCartographie) {
  const values = {
    auto: '',
    formats: [],
    materiels: [],
    codesPostaux: [],
    villes: [],
    departements: [],
    supports: [],
    references: [],
    agglomeration: [],
    anglesVision: [],
    localisations: [],
    agencesId: [],
    actif: true,
    adresses: [],
    eclaire: null,
    avecLiaisonsTarif: null,
    regroupementProduitIds: [],
    dateReferenceAffectation: new Date(),
  };
  if (isCartographie) {
    values.avecCoordonnees = true;
  }
  return values;
}
